import { useCallback, forwardRef } from 'react'
import { motion } from 'framer-motion'
import { Eye, EyeOff } from 'lucide-react'
import { cn } from '@/lib/utils'
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuTrigger,
} from '@/components/ui/context-menu'
import { CommandCenter } from '@/components/command-center'
import { smoothSpring } from './motion-presets'
export function CommandCenterSection({
  showCommandCenter,
  handleCreateStart,
  handleCommandUndo,
  handleCommandRedo,
  historySnap,
  handleToggleWeatherUnit,
  weatherUnit,
  handleToggleTimeFormat,
  timeFormat,
  showTime,
  showWeather,
  handleToggleTimeVisibility,
  handleToggleWeatherVisibility,
  handleToggleVisibility,
  loadItem,
}) {
  const handleCreateTodo = useCallback(() => {
    handleCreateStart('todo')
  }, [handleCreateStart])
  return (
    <motion.div variants={loadItem}>
      <ContextMenu>
        <ContextMenuTrigger asChild>
          <CommandCenterWrapper
            showCommandCenter={showCommandCenter}
            handleCreateTodo={handleCreateTodo}
            handleCommandUndo={handleCommandUndo}
            handleCommandRedo={handleCommandRedo}
            historySnap={historySnap}
            handleToggleWeatherUnit={handleToggleWeatherUnit}
            weatherUnit={weatherUnit}
            handleToggleTimeFormat={handleToggleTimeFormat}
            timeFormat={timeFormat}
            showTime={showTime}
            showWeather={showWeather}
            handleToggleTimeVisibility={handleToggleTimeVisibility}
            handleToggleWeatherVisibility={handleToggleWeatherVisibility}
          />
        </ContextMenuTrigger>
        <ContextMenuContent>
          <CommandCenterVisibilityItem
            showCommandCenter={showCommandCenter}
            handleToggleVisibility={handleToggleVisibility}
          />
        </ContextMenuContent>
      </ContextMenu>
    </motion.div>
  )
}
const CommandCenterWrapper = forwardRef(
  (
    {
      showCommandCenter,
      handleCreateTodo,
      handleCommandUndo,
      handleCommandRedo,
      historySnap,
      handleToggleWeatherUnit,
      weatherUnit,
      handleToggleTimeFormat,
      timeFormat,
      showTime,
      showWeather,
      handleToggleTimeVisibility,
      handleToggleWeatherVisibility,
      ...props
    },
    ref,
  ) => {
    return (
      <motion.div
        layout="position"
        ref={ref}
        transition={smoothSpring}
        animate={
          showCommandCenter
            ? {
                opacity: 1,
                y: 0,
              }
            : {
                opacity: 0,
                y: -10,
              }
        }
        className={cn(!showCommandCenter && 'pointer-events-none h-0 overflow-hidden')}
        {...props}
      >
        <CommandCenter
          onCreateTask={handleCreateTodo}
          onUndo={handleCommandUndo}
          onRedo={handleCommandRedo}
          canUndo={historySnap.past.length > 0}
          canRedo={historySnap.future.length > 0}
          onToggleWeatherUnit={handleToggleWeatherUnit}
          currentWeatherUnit={weatherUnit}
          onToggleTimeFormat={handleToggleTimeFormat}
          timeFormat={timeFormat}
          showTime={showTime}
          showWeather={showWeather}
          onToggleTimeVisibility={handleToggleTimeVisibility}
          onToggleWeatherVisibility={handleToggleWeatherVisibility}
        />
      </motion.div>
    )
  },
)
CommandCenterWrapper.displayName = 'CommandCenterWrapper'
const CommandCenterVisibilityItem = ({ showCommandCenter, handleToggleVisibility }) => (
  <ContextMenuItem data-visibility-key="showCommandCenter" onClick={handleToggleVisibility}>
    {showCommandCenter ? <EyeOff className="mr-2 h-4 w-4" /> : <Eye className="mr-2 h-4 w-4" />}
    {showCommandCenter ? 'Hide' : 'Show'}
  </ContextMenuItem>
)
